// extracted by mini-css-extract-plugin
export default {"root":"SectionContainer_root__60z3Q","sectionContent":"SectionContainer_sectionContent__EIWmm","backgroundImageWrapper":"SectionContainer_backgroundImageWrapper__wyumR"};